<template>
  <div>
    <!--分页-->
    <div id="page-break">
      <ul>
        <li v-if="page_>1">
          <a v-on:click="page_--,pageClick()">上一页</a>
        </li>
        <li v-if="page_==1">
          <a class="banclick">上一页</a>
        </li>
        <li v-for="item in indexs" v-bind:class="{'active':page_==item}">
          <a v-on:click="page_=item, pageClick()">{{item}}</a>
        </li>
        <li v-if="page_!=all_">
          <a v-on:click="page_++,pageClick()">下一页</a>
        </li>
        <li v-if="page_==all_">
          <a class="banclick">下一页</a>
        </li>
        <li><a>共<i>{{all_}}</i>页</a></li>
        <div class="jumpbox">
          <input type="number" class="jumppage" />
          <a class="jumpbtn" v-on:click="pageSkip()">跳转</a>
        </div>

        <div class="btn-group dropup">
          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">每页<span>{{rows_}}</span>条
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" role="menu">
            <li><a href="#" @click="page_==1;rows_=10;pageClick()">10条</a></li>
            <li><a href="#" @click="page_==1;rows_=15;pageClick()">15条</a></li>
            <li><a href="#" @click="page_==1;rows_=20;pageClick()">20条</a></li>
          </ul>
        </div>

      </ul>
    </div>
  </div>
</template>

<script>

  export default {
    name: "page-view",
    data() {
      return {
        "page_" : this.$props.page,
        "rows_" : this.$props.rows,
        "all_" : this.$props.all
      }
    },
    props:["page", "rows", "cur", "all", "pageCallback"],
    watch:{
      all(){
        this.page_ = this.$props.page;
        this.rows_ = this.$props.rows;
        this.all_ = this.$props.all;
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        //this_.page_ = 1;
      })
    },
    computed: {
      indexs(){
        if(!this.all_ || !this.page_) return [];
        var left = 1;
        var right = this.all_;
        var arr = [];
        if(this.all_>=7){
          if(this.page_>4 && this.page_<this.all_-3){
            left = this.page_-3;
            right = this.page_+3;
          }else if(this.page_<=4){
            left=1;
            right=7;
          }else{
            left=this.all_-6;
            right=this.all_;
          }
        }
        while(left<=right){
          arr.push(left);
          left++;
        }
        return arr;
      }
    },
    methods: {
      /**
       * 分页
       */
      pageClick(){
        let this_=this;
        var callback = this_.pageCallback;
        if(typeof callback === "function"){
          var pageParams = {
            page : this.page_,
            rows : this.rows_,
            all : this.all_
          };
          callback.call(this.$parent, pageParams);
        }
      },
      pageSkip(){
        var maxPage = this.all_;
        var skipPage = Number(document.getElementsByClassName("jumppage")[0].value);
        //console.log(typeof skipPage);
        if(!skipPage){
          alert("请输入跳转页码");
          return;
        }else if(skipPage<1 || skipPage>maxPage){
          alert("您输入的页码超过页数范围了！");
          return;
        }else{
          this.page_=skipPage;
          // this.btnClick(skipPage);
          this.pageClick();
        }
      }
    }
  }
</script>

<style scoped>
#page-break {
  margin-top: 20px;
  margin-left: 20%;
  /*  position: absolute;
    top: 50%;
    left: 50%;*/
  /*transform: translate(10%,-50%);*/
}
#page-break li {
  list-style: none;
}
#page-break a {
  border: 1px solid #ddd;
  text-decoration: none;
  float: left;
  padding: 6px 12px;
  color: #d44950;
  cursor: pointer}
#page-break a:hover {
  background-color: #eee;
}
#page-break a .banclick {
  cursor: not-allowed;
}
#page-break .active a {
  color: #fff;
  cursor: default;
  background-color: #d44950;
  border-color: #ff6f66;
}
#page-break i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
#page-break .jumpbox .jumppage {
  border: 1px solid #ddd;
  margin-left: 40px;
  height: 33px;
  width: 40px;
  float: left;
}
#page-break .jumpbox .jumpbtn {
  cursor: pointer;
  margin-left: 10px;
}
#page-break .jumpbox .jumpbtn:active {
  color: #337ab7;
}
  .dropdown-menu {
    min-width: 80px;
  }
  .dropdown-menu li {
    margin: 0 0 0 12%;
  }
  .dropdown-toggle {
    color: #d44950;
  }
</style>



// WEBPACK FOOTER //
// src/components/pageView.vue